// extracted by mini-css-extract-plugin
export default {"button":"DealerFavoriteButton_button__6pqpU","active":"DealerFavoriteButton_active__IktVj","large":"DealerFavoriteButton_large__Xz-SD"};